import routes from '@routes/config';

export default [{
    path: routes.sign.index,
    name: routes.sign.index,
    component: () => import(/* webpackChunkName: "Sign" */  '@components/Sign/Index')
}]
